exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\n.login-holder {\n  height: 100vh; }\n.mat-card-title {\n  padding-bottom: 10px; }\n.login {\n  background-size: cover;\n  background-position: center;\n  height: 100%; }\n.login form {\n    position: relative;\n    top: 60%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%); }\n.login label {\n    color: #ffffff; }\n.login .btn {\n    margin-top: 20px; }\n.login input {\n    border: none; }\ninput[type=\"email\"].ng-invalid {\n  border: 1px solid #404040 !important; }\n.modal-footer {\n  text-align: center; }\n.logo {\n  background: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/auth/login/login.component.scss
// module id = ../../../../../src/app/auth/login/login.component.scss
// module chunks = main